import {SIGNIN_GUEST} from '../action_types'

export default function () {
  return {type: SIGNIN_GUEST}
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/actions/sign_in_guest.js
 **/